import { useMediaQuery, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import moment from 'moment';
import { ComplaintApi, complaintListFront, type_complaint_status } from '../../../api/complaint/complaint.api';
import { complaintType, ComplaintTypeApi } from '../../../api/complaint-type/complaint_type.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { COMPLAINTS_STATUS, COMPLAINTS_STATUS_DATA } from './enum/complaint.enum';
import StatusCustom from '../../../components/status/statusCustom';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';

const ManageStateComplaintSubmitList = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    // const [search, setSearch] = useState<string>("");
    const [data, setData] = useState<any[]>([]);
    const [date_range, set_date_range] = useState<string[]>([]);
    const [complaint_type_data, set_complaint_type_data] = useState<any[]>([]);
    const [id_complaints_type, set_id_complaints_type] = useState<any>(null);
    const [search_complaint_type, set_search_complaint_type] = useState<string>("");
    const [status, set_status] = useState<string>("");


    const handleChangeDateRange = (date_range_value: string[]) => {
        set_date_range(date_range_value)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "subject_no", width: 50, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 120, align: "center", label: t("COMPLAINTS_COMPLAINT_CATEGORY")
        },
        {
            id: "subject", disablePadding: false, align: "left", width: 150, label: t("COMPLAINTS_SUBJECT")
        },
        // {
        //     id: "subject_detail", disablePadding: false, align: "center", width: 100, label: "รายละเอียด"
        // },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("COMPLAINTS_SUBMITTED_DATE")
        },
        {
            id: "s", disablePadding: false, align: "center", width: 120, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            // courses_no,
            // // courses_name,
            // // credits,
            // // status,
            // created_date,
            // modified_date,
            complaints_subject,
            complaints_type_name,
            complaints_desc,
            submit_date,
            complaints_status,
            id_complaints
        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                { option: "TEXT", align: "center", label: complaints_type_name || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: complaints_subject || "-",
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: complaints_desc || "-",
                // },
                {
                    option: "TEXT",
                    align: "center",
                    label: submit_date ? moment(submit_date).add(543, 'year').format("DD/MM/YYYY") : "-"
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: moment(modified_date || created_date || new Date()).add(543, 'year').format('l') || created_date || "-",
                // },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-between items-center'>
                        <StatusCustom
                            disableMaxWidth
                            text={`${t(COMPLAINTS_STATUS_DATA.find((x) => x.value === complaints_status)?.label || "")}`}
                            type={`${t(COMPLAINTS_STATUS_DATA.find((x) => x.value === complaints_status)?.label || "")}`}
                        />
                        <OptionsButtonCustom
                            enableEdit={complaints_status === COMPLAINTS_STATUS.DRAFT}
                            enableView
                            enableDelete={complaints_status === COMPLAINTS_STATUS.DRAFT}
                            onEditClick={() => navigate(routeName.students.complaintSubmitDetail.replace(":id", id_complaints))}
                            onViewClick={() => navigate(routeName.students.complaintSubmitDetailView.replace(":id", id_complaints))}
                            onDeleteClick={() => handleDelete(id_complaints)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDelete = (id_complaints: number) => {
        alertActive(t("COMPLAINTS_DELETE_ITEM"), t("COMPLAINTS_CONFIRM_DELETE_ITEM"), undefined, undefined, async () => {
            const body: type_complaint_status = {
                complaints_status: COMPLAINTS_STATUS.CANCEL
            }
            dispatch(setLoading());
            await ComplaintApi.updateStatus(id_complaints, body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COMPLAINTS_DELETE_ITEM"), t("COMPLAINTS_DELETE_SUCCESS"));
                    handleGetData();
                }
            }).catch((err) => {
                alertError(t("COMPLAINTS_DELETE_ITEM"), t("COMPLAINTS_DELETE_FAILED"))
                throw err
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetComplaintType = useCallback(async () => {
        let query: complaintType = {
            page: 1,
            limit: 20
        }
        if (search_complaint_type) query = { ...query, keyword: search_complaint_type }
        await ComplaintTypeApi.getList(query).then((res) => {
            if (res.status < 300) {
                set_complaint_type_data(res.data?.data?.items || [])
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_complaint_type])


    const handleGetData = useCallback(async () => {
        let query: complaintListFront = {
            page: page,
            limit: pageLimit
        }
        if (id_complaints_type) query = { ...query, id_complaints_type: id_complaints_type?.id_complaints_type }
        if (date_range?.length === 2 && date_range?.every((x) => moment(x).isValid())) {
            query = { ...query, start_date: moment(date_range[0]).format("YYYY-MM-DD") }
            query = { ...query, end_date: moment(date_range[1]).format("YYYY-MM-DD") }
        }
        if (status) query = { ...query, complaints_status: status }
        dispatch(setLoading());
        await ComplaintApi.getListFront(query).then((res) => {
            if (res.status < 300) {
                console.log(res.data)
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_complaints_type, date_range, status])

    useEffect(() => {
        handleGetComplaintType();
    }, [handleGetComplaintType])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        // setSearch,
        handleChangeDateRange,
        date_range,
        set_search_complaint_type,
        complaint_type_data,
        id_complaints_type,
        set_id_complaints_type,
        status,
        set_status
    }
}

export default ManageStateComplaintSubmitList
